import React from "react"

export default class ArticleTimer extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			failures: 0,
			start_time: new Date()
		}
	}

	componentDidMount() {
		var self = this;

		self.timer = setInterval(function () {
			if (self.state.failures >= 7) {
				//console.log('at least 7 failures! clear timer');
				clearInterval(self.timer);
				return;
			}

			var diff = self.state.start_time.getTime() - new Date().getTime();
			var diff_in_seconds = Math.abs(parseInt(diff / 1000));

			if (diff_in_seconds / 60 >= self.props.timeout) {
				//console.log('exceeded max timeout - clear timer');
				clearInterval(self.timer);
				return;
			}
			
			//console.log('timer!', diff_in_seconds);

			$.ajax({
        type: 'POST',
        url: self.props.path,
        data: {
          article_view_id: self.props.article_view.id,
          time_in_seconds: diff_in_seconds,
        },
      }).done(function (data) {
        //console.log('done update article time', data);
      }).fail(function (data) {
      	//console.log(self.props.path + ' failed!');
      	self.setState({failures: self.state.failures + 1});
      });
		}, 1000);
	}

	render() {
		//console.log('render ArticleTimer', this.props);
		return null;
	}

}